import React from 'react'
import PropTypes from 'prop-types'

const AccountManagementButton = (props) => (
    <button className="AccountManagementButton" onClick={props.click}><span>{props.text}</span></button>
)

AccountManagementButton.propTypes = {
    click: PropTypes.func,
    text: PropTypes.string.isRequired
}

export default AccountManagementButton


// WEBPACK FOOTER //
// ./src/components/AccountManagementControl/AccountManagementButton.js